import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';
import { addNotificationAction } from '../notifications/notifications';

export const updateOrgDefaultNotificationSettings = (orgId: number, jobId: number) =>
  createGenericDispatcher({
    name: 'UPDATE_ORGANIZATION_DEFAULT_NOTIFICATION_SETTINGS',
    loadFunction: () =>
      Api.post(`/org/${orgId}/default-notification-settings`, {
        body: JSON.stringify({
          jobId,
        }),
      }),
    args: { orgId, jobId },
    onSuccess: (dispatch) => {
      dispatch(
        addNotificationAction({
          key: `update-org-notification-${orgId}-${jobId}`,
          message: 'Updated Company Defaults',
        }),
      );
    },
  });
